<template>
  <div
    class="container m-auto flex flex-col md:flex-row mt-8 gap-4"
  >
    <aside
      class="md:w-3/12 xl:w-2/12 space-y-5 space-y-reverse"
    >
      <div
        class="tab-section flex items-center rounded-[32px] bg-white py-[15px] px-6 h-16 md:block md:h-auto overflow-hidden overflow-x-scroll md:overflow-auto"
      >
        <img
          class="w-full"
          :src="logoSrc"
          alt=""
        />
        <a
          v-show="!accountStatsLoading && accountStats.active_lines > 0"
          href="https://sms.ir/panel/" target="_blank"
          class="BTNMAIN py-2 px-4 flex gap-2 items-center justify-center mt-4"
        >
          <span class="text-[#0D0D0D] text-sm">{{ $t('loginInPanel') }}</span>
        </a>
        <a
          v-show="!accountStatsLoading && !accountStats.active_lines"
          href="https://sms.ir/panel/" target="_blank"
          class="BTNMAIN py-2 px-4 flex gap-2 items-center justify-center mt-4"
        >
          <span class="text-[#0D0D0D] text-sm">{{ $t('registerInPanel') }}</span>
        </a>
        <div
          class="flex items-center justify-between w-full mt-4"
          v-if="accountStats"
        >
          <div
            class="flex items-center justify-center gap-1"
          >
            <i class="text-xl icon-smsir-wallet"></i>
            <p
              class="text-sm font-normal text-[#4D4D4D]"
            >
              {{ $t("account.credit") }} :
            </p>
          </div>
          <div
            class="stat-content flex items-center"
          >
            <p
              class="text-xs font-light text-[#4D4D4D]"
            >
              {{
                formatNumber(accountStats.credit)
              }}
              {{ $t("SMS") }}
            </p>
          </div>
        </div>
        <hr class="h-1 text-[#D9D9D9] my-4" />
        <ul
          class="flex md:flex-wrap text-sm leading-5 text-main-400 space-x-1 md:space-x-0 md:space-y-1 md:flex [&>*]:cursor-pointer [&>*]:md:w-full [&>*]:flex [&>*]:items-center gap-2 [&>*]:gap-2 [&>*]:rounded-2xl [&>*]:px-3 [&>*]:py-3 [&>*]:w-40 [&>*]:!text-xs [&>*]:md:text-base flex-row [&>*]:md:!m-0"
        >
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'general',
            }"
            @click.prevent="
              handleTabClick('general')
            "
          >
            <i
              class="icon-smsir-settings text-[18px]"
            ></i>
            <p>
              {{ $t("generalSettings") }}
            </p>
            <i
              v-if="currentTab === 'general'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'login',
            }"
            @click.prevent="
              handleTabClick('login')
            "
          >
            <i class="icon-smsir-login text-[18px]"></i>

            <p>
              {{ $t("loginSettings") }}
            </p>
            <i
              v-if="currentTab === 'login'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'shortcode',
            }"
            @click.prevent="
              handleTabClick('shortcode')
            "
          >
            <i class="icon-smsir-code text-[18px]"></i>

            <p>
              {{ $t("shortCodes") }}
            </p>
            <i
              v-if="currentTab === 'shortcode'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'woocommerce',
            }"
            @click.prevent="
              handleTabClick('woocommerce')
            "
          >
            <i class="icon-smsir-box text-[18px]"></i>
            <p>
              {{ $t("OrderStatusSettings") }}
            </p>
            <i
              v-if="currentTab === 'woocommerce'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'template',
            }"
            @click.prevent="
              handleTabClick('template')
            "
          >
            <i
              class="icon-smsir-window text-[18px]"
            ></i>

            <p>
              {{ $t("templateManager") }}
            </p>
            <i
              v-if="currentTab === 'template'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
      

          <li
            class="main tab-title-selected"
        :class="{
              active: currentTab == 'forms',
        }"
            @click.prevent="
              handleTabClick('forms')
            "
      >
            <i class="icon-smsir-comment text-[18px]"></i>
            <p>
              {{ $t("formsGenerator") }}
            </p>
            <i
              v-if="currentTab === 'forms'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>

          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'leavecart',
            }"
            @click.prevent="
              handleTabClick('leavecart')
            "
          >
            <i class="icon-smsir-leave-box text-[18px]"></i>
            <p>
              {{ $t("abandonedPurchase") }}
            </p>
            <i
              v-if="currentTab === 'leavecart'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          
          <!-- Excel Upload Tab -->
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'excelupload',
            }"
            @click.prevent="
              handleTabClick('excelupload')
            "
          >
            <i class="icon-smsir-send text-[18px]"></i>
            <p>
              {{ $t("excelUpload") || "Excel Upload" }}
            </p>
            <i
              v-if="currentTab === 'excelupload'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'notifyme',
            }"
            @click.prevent="
              handleTabClick('notifyme')
            "
          >
            <i class="icon-smsir-alert text-[18px]"></i>
            <p>
              {{ $t("notifyMeSettings") }}
            </p>
            <i
              v-if="currentTab === 'notifyme'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'newsletter',
            }"
            @click.prevent="
              handleTabClick('newsletter')
            "
          >
          <i class="icon-smsir-settings text-[18px]"></i>

            <p>
              {{ $t("newsLetter") }}
            </p>
            <i
              v-if="currentTab === 'newsletter'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'contacts',
            }"
            @click.prevent="
              handleTabClick('contacts')
            "
          >
            <i class="icon-smsir-send text-[18px]"></i>
            <p>
              {{ $t("contacts.title") }}
            </p>
            <i
              v-if="currentTab === 'contacts'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <li
            class="main tab-title-selected"
            :class="{
              active: currentTab == 'reports',
            }"
            @click.prevent="
              handleTabClick('reports')
            "
          >
          <i class="icon-smsir-settings text-[18px]"></i>

            <p>
              {{ $t("Reports") }}
            </p>
            <i
              v-if="currentTab === 'reports'"
              class="icon-smsir-dropdown mr-auto text-[12px] text-main rotate-90"
            ></i>
          </li>
          <!-- Contacts Tab -->
      
        </ul>
      </div>
    </aside>
    <div
      class="flex flex-col gap-6 w-full md:w-9/12 xl:w-10/12"
    >
      <div
        v-if="accountStats"
        class="w-full flex items-center gap-6 content-section [&>*]:rounded-[15px] [&>*]:border-[#D9D9D9] [&>*]:border [&>*]:bg-white">
        <div
          class="w-full flex items-center gap-3 p-4"
        >
          <div
            class="w-10 flex items-center justify-center"
          >
            <i
              class="text-2xl text-[#FFBF00] icon-smsir-round-check"
            ></i>
          </div>
          <div class="stat-content">
            <h4
              class="text-sm text-[#4D4D4D]"
            >
              {{ $t("account.conection_status") }}
            </h4>
            <p v-if="accountStats.active_lines > 0" class="text-green-500">
              {{ $t("account.connected") }}
            </p>
            <div v-else class="flex items-center gap-2">
              <button 
                @click="handleDisconnectedClick"
                class="text-red-500 hover:text-red-700 transition-colors duration-200"
              >
                <i class="icon-smsir-refresh text-lg"></i>
              </button>
              <p class="text-red-500">
                {{ $t("account.disconnected") }} 
              </p>
            </div>
          </div>
        </div>
        <div
          class="w-full flex items-center gap-3 p-4"
        >
          <div
            class="w-10 flex items-center justify-center"
          >
            <i
              class="text-2xl text-[#FFBF00] icon-smsir-round-check"
            ></i>
          </div>
          <div class="stat-content">
            <h4
              class="text-sm text-[#4D4D4D]"
            >
              {{ $t("account.active_lines") }}
            </h4>
            <p>
              {{
                formatNumber(
                  accountStats?.active_lines
                )
              }}
            </p>
          </div>
        </div>
        <div
          class="w-full flex items-center gap-3 p-4"
        >
          <div
            class="w-10 flex items-center justify-center"
          >
            <i
              class="text-2xl text-[#FFBF00] icon-smsir-inbox-out-2"
            ></i>
          </div>
          <div class="stat-content">
            <h4
              class="text-sm text-[#4D4D4D]"
            >
              {{ $t("account.today_sent") }}
            </h4>
            <p>
              {{
                formatNumber(
                  accountStats.today_sent
                )
              }}
            </p>
          </div>
        </div>
        <div
          class="w-full flex items-center gap-3 p-4"
        >
          <div
            class="w-10 flex items-center justify-center"
          >
            <i class="text-2xl text-[#FFBF00] icon-smsir-inbox-in-2"></i>
          </div>
          <div class="stat-content">
            <h4
              class="text-sm text-[#4D4D4D]"
            >
              {{ $t("account.today_received") }}
            </h4>
            <p>
              {{
                formatNumber(
                  accountStats.today_received
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <article
        class="settings-section rounded-[30px] !bg-white border border-[#D9D9D9] px-8 pt-6 pb-12"
      >
        <GeneralSettings
          :settings="checkedSettings"
          v-show="currentTab == 'general'"
        />
        <LoginSettings
          :settings="checkedSettings"
          v-show="currentTab == 'login'"
        />
        <ShortCodes
          :settings="checkedSettings"
          v-show="currentTab == 'shortcode'"
        />
        <WooCommerceSettings
          v-if="currentTab === 'woocommerce'"
          class="w-full"
        />
        <TemplateManager
          :settings="checkedSettings"
          :active="currentTab === 'template'"
          v-if="currentTab === 'template'"
          class="w-full"
        />
        <ErrorReports
          v-if="currentTab === 'reports'"
          class="w-full"
        />
        <NewsletterManager
          v-if="currentTab === 'newsletter'"
          class="w-full"
        />
        <GravityFormsSettings
        :settings="checkedSettings"
          v-if="currentTab === 'forms'"
          class="w-full"
        />
        <LeaveCartSettings
          v-if="currentTab === 'leavecart'"
          class="w-full"
        />
        <ExcelUpload
          v-if="currentTab === 'excelupload'"
          :settings="checkedSettings"
        />
        <NotifyMeSettings
          v-if="currentTab === 'notifyme'"
          :settings="checkedSettings"
        />
        <ContactsTab
          v-if="currentTab === 'contacts'"
        />
      </article>
    </div>
  </div>
  <div class="container m-auto mt-4">
    <div
      class="flex flex-col md:flex-row items-center gap-5 justify-end relative"
    >
      <button
        @click.prevent="saveSettings"
        v-show="
          readOnly.indexOf(currentTab) === -1
        "
        class="z-50 BTNMAIN px-9 items-center text-xs md:text-base justify-center w-full md:w-max focus:outline-none focus:border-none hover:bg-white hover:text-main"
        :class="{
          'pointer-events-none': saving,
        }"
        href="#"
      >
        <span v-if="saving">{{
          $t("Saving")
        }}</span>
        <span v-else>{{
          $t("SaveChanges")
        }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import LoginSettings from "./tabs/LoginSettings.vue";
import GeneralSettings from "./tabs/GeneralSettings.vue";
import ShortCodes from "./tabs/ShortCodes.vue";
import TemplateManager from "./tabs/TemplateManager.vue";
import ErrorReports from "./tabs/ErrorReports.vue";
import NewsletterManager from "./tabs/NewsletterManager.vue";
import GravityFormsSettings from "./tabs/GravityFormsSettings.vue";
import WooCommerceSettings from "./tabs/WooCommerceSettings.vue";
import LeaveCartSettings from "./tabs/LeaveCartSettings.vue";
import ExcelUpload from "./tabs/ExcelUpload.vue";
import NotifyMeSettings from "./tabs/NotifyMeSettings.vue";
import ContactsTab from "./tabs/ContactsTab.vue";

export default {
  components: {
    GeneralSettings,
    LoginSettings,
    ShortCodes,
    TemplateManager,
    ErrorReports,
    NewsletterManager,
    GravityFormsSettings,
    WooCommerceSettings,
    LeaveCartSettings,
    ExcelUpload,
    NotifyMeSettings,
    ContactsTab,
  },
  data() {
    return {
      readOnly: [
        "shortcode",
        "template",
        "reports",
        "forms",
        "woocommerce",
        "newsletter",
        "leavecart",
        "excelupload",
        "contacts"
            ],
      sms_ir_login: window.sms_ir_login || "",
      currentTab: "general",
      selectedTab: "general",
      currentSub: 1,
      buyed_product: {},
      defaultSettings: {
        settings: {
          general: {
            api_key: '',
            secret_key: '',
            line_number: '',
            is_active: true,
            logo_url: '',
            enable_credit_notification: false,
            credit_threshold: 100
          },
          login: {
            is_active: false,
            change_admin:false,
            template_id: '',
            message: '',
            show_logo: true,
            show_copyright: true,
            logo_url: '',
            enable_otp: false,
            otp_length: 5,
            otp_expiry: 90
          },
          login_style: {
            modal_button_text: '',
            modal_button_bg: '#FFBF00',
            modal_button_text_color: '#0D0D0D',
            modal_background: '#FFFFFF',
            form_background: '#FFFFFF',
            primary_button_bg: '#FFBF00',
            primary_button_text_color: '#0D0D0D'
          },
          newsletter: {
            is_active: false,
            template_id: '',
            message: '',
            logo_url: '',
            enable_double_optin: false
          },
          forms: {
            is_active: false,
            template_id: '',
            message: '',
            logo_url: ''
          },
          woocommerce: {
            is_active: false,
            change_checkout: false,
            notifications: []
          },
          notifyme: {
            is_active: false,
            template_id: '',
            button_text: '',
            notification_text: '',
            enable_button: true,
            button_style: 'default'
          }
        }
      },
      checkedSettings: {
        settings: {
          general: {
            api_key: '',
            secret_key: '',
            line_number: '',
            is_active: true,
            enable_credit_notification: false,
            credit_threshold: 100
          },
          login: {
            is_active: false,
            change_admin:false,
            template_id: '',
            message: '',
            show_logo: true,
            show_copyright: true,
            logo_url: '',
            enable_otp: false,
            otp_length: 5,
            otp_expiry: 90
          },
          login_style: {
            modal_button_text: '',
            modal_button_bg: '#FFBF00',
            modal_button_text_color: '#0D0D0D',
            modal_background: '#FFFFFF',
            form_background: '#FFFFFF',
            primary_button_bg: '#FFBF00',
            primary_button_text_color: '#0D0D0D'
          },
          newsletter: {
            is_active: false,
            template_id: '',
            message: '',
            logo_url: '',
            enable_double_optin: false
          },
          forms: {
            is_active: false,
            template_id: '',
            message: '',
            logo_url: ''
          },
          woocommerce: {
            is_active: false,
            change_checkout: false,
            notifications: []
          },
          notifyme: {
            is_active: false,
            template_id: '',
            button_text: '',
            notification_text: '',
            enable_button: true,
            button_style: 'default'
          }
        }
      },
      show: true,
      warning: false,
      saving: false,
      accountStats: null,
      accountStatsError: null,
      accountStatsLoading: true,
      logoSrc:
        window.sms_ir_login?.pluginUrl +
        "/img/logo.svg",
    };
  },
  mounted() {
    this.selectTabFromQuery();
    window.addEventListener(
      "popstate",
      this.selectTabFromQuery
    );
    
    // Wait for WordPress core to be fully loaded
    if (typeof wp === 'undefined') {
      const checkWpLoaded = setInterval(() => {
        if (typeof wp !== 'undefined' && wp.hooks) {
          clearInterval(checkWpLoaded);
          this.initializeAfterWpLoaded();
        }
      }, 100);
    } else {
      this.initializeAfterWpLoaded();
    }
  },
  methods: {
    initializeAfterWpLoaded() {
      this.fetchAccountStats();
      this.initializeSettings();
    },
    selectTabFromQuery() {
      const url = new URL(window.location.href);
      const tab = url.searchParams.get("tab");
      if (tab) {
        this.currentTab = tab;
      }
    },
    async initializeSettings() {
      try {
        const response = await axios.post(
          `${this.sms_ir_login.ajaxUrl}`,
          {
            nonce: `${this.sms_ir_login.nonce}`,
            action: "sms_ir_get_settings",
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
          }
        );

        if (response.data && response.data.settings) {
          this.checkedSettings = {
            settings: this.mergeSettings(this.defaultSettings.settings, response.data.settings)
          };
        } else {
          await this.saveDefaultSettings();
        }
      } catch (error) {
        console.error("Error initializing settings:", error);
        await this.saveDefaultSettings();
      }
    },

    mergeSettings(defaults, existing) {
      const merged = { ...defaults };
      
      Object.keys(existing).forEach(key => {
        if (typeof existing[key] === 'object' && !Array.isArray(existing[key])) {
          merged[key] = this.mergeSettings(defaults[key] || {}, existing[key]);
        } else {
          merged[key] = existing[key];
        }
      });
      
      return merged;
    },

    async saveDefaultSettings() {
      try {
        const data = {
          nonce: this.sms_ir_login.nonce,
          action: "sms_ir_save_settings",
          settings: this.defaultSettings.settings
        };

        const response = await axios.post(
          `${this.sms_ir_login.ajaxUrl}`,
          data,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
          }
        );

        if (response.data.success) {
          this.checkedSettings = {
            settings: this.defaultSettings.settings
          };
        } else {
          this.checkedSettings = {
            settings: this.defaultSettings.settings
          };
        }
      } catch (error) {
        console.error("Error saving default settings:", error);
        this.checkedSettings = {
          settings: this.defaultSettings.settings
        };
      }
    },
    handleTabClick(index, sub = 1) {
      this.currentTab = index;
      this.currentSub = sub;
      this.show = true;
      this.redirect = false;
      const url = new URL(window.location.href);
      url.searchParams.set("tab", index);
      window.history.pushState({}, "", url);
    },
    async saveSettings() {
      try {
        this.saving = true;
        this.checkedSettings;
        let data = this.checkedSettings;
        data.nonce = this.sms_ir_login.nonce;
        data.action = "sms_ir_save_settings";
        const response = await axios.post(
          `${this.sms_ir_login.ajaxUrl}`,
          data,
          {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded",
            },
            withCredentials: true,
          }
        );
        if (response.data.setting) {
          this.checkedSettings =
            response.data.setting;
        }
        if (response.data.success) {
          this.saving = false;
          Swal.fire({
            text:
              response.data.message ||
              this.$t(
                "SettingsSavedSuccessfully"
              ),
            icon: "success",
            toast: true,
            position: "top-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "smsir-swal",
            },
          });
        }
      } catch (error) {
        this.saving = false;
        let errorMessage = this.$t(
          "SettingsSaveError"
        );

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage =
            error.response.data.message;
        }

        Swal.fire({
          text: errorMessage,
          icon: "error",
          toast: true,
          position: "top-start",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "smsir-swal",
          },
        });
        console.error(
          "Error saving settings:",
          error
        );
      }
    },
    async fetchAccountStats() {
      try {
        this.accountStatsLoading = true;
        const response = await axios.post(
          window.sms_ir_login.ajaxUrl,
          new URLSearchParams({
            action: "sms_ir_get_account_stats",
            nonce: window.sms_ir_login.nonce,
            type: "all",
          }),
          {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded",
            },
          }
        );
        
        if (response.data && response.data.success) {
          this.accountStats = response.data.data || {
            active_lines: 0,
            credit: 0,
            today_sent: 0,
            today_received: 0
          };
        } else {
          this.accountStats = {
            active_lines: 0,
            credit: 0,
            today_sent: 0,
            today_received: 0
          };
        }
      } catch (error) {
        console.error("Error fetching account stats:", error);
        this.accountStatsError = error.response?.data?.message || "Failed to fetch account stats";
        this.accountStats = {
          active_lines: 0,
          credit: 0,
          today_sent: 0,
          today_received: 0
        };
      } finally {
        this.accountStatsLoading = false;
      }
    },
    formatNumber(num) {
      if (num === null || num === undefined)
        return "0";
      if (
        typeof num === "number" &&
        !Number.isInteger(num)
      ) {
        num = Math.floor(num);
      }
      return num.toLocaleString("fa-IR");
    },
    handleDisconnectedClick() {
      Swal.fire({
        title: this.$t('recheckConnection'),
        text: this.$t('recheckConnectionDescription'),
        icon: 'info',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: 'smsir-swal',
          title: 'text-[18px] text-[#0D0D0D]',
          content: 'text-[#4D4D4D]',
          timerProgressBar: 'bg-[#12BA6C]'
        },
        didOpen: () => {
          Swal.showLoading();
        }
      }).then(() => {
        window.location.reload();
      });
    },
  },
  computed: {
    isWooCommerceActive() {
      return window.sms_ir_login?.woocommerce_active === true;
    },
  },
};
</script>
